import { Subscription } from 'rxjs';
import { Component, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { CardTableComponent } from 'libs/portal/src/modules/tools/card-table/components';
import { CardTableAction, CardTableOptions } from 'libs/portal/src/modules/tools/card-table/models';
import { CardTableHeader } from 'libs/portal/src/modules/tools/card-table/models/card-table-header.model';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { MemoryService } from 'libs/portal/src/services/memory/memory.service';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { PaginationService } from 'libs/portal/src/services/pagination/pagination.service';
import { TitleService } from 'libs/portal/src/services/title/title.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { Routes } from '@huge-monorepo/portal/config';
import { GenericTableHeaderOptions, RefreshData } from 'libs/portal/src/modules/tools/card-table/models/generic-table-header-options.model';
import { openFileImportDialog } from 'libs/portal/src/modules/tools/file-import-modal/file-import-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';

export interface Device {
  id: number;
  name: string;
  data: string;
  status: string;
  selected: boolean;
  color: string;
}

@Component({
  selector: 'app-cdr-devices',
  templateUrl: './cdr-devices.component.html',
  styleUrls: ['./cdr-devices.component.scss'],
})
export class CdrDevicesComponent implements OnInit, OnDestroy {
  @ViewChild('sticky') sticky: TemplateRef<any>;
  @ViewChild('CDRTable', { static: false }) public CDRTable: CardTableComponent;

  data: Device[] = [];
  ScreenSize = ScreenSize;

  totalCdrDevices: number;
  loadingCDRDevices = false;
  cdrLoadingError = false;
  orderCDRBy = `Usage`;
  cdrTableCount = 10;
  cdrSearch = '';
  cdrTableOffset = 0;
  currentCDRPage = 1;
  cdrDesc = true;

  firstLoad = true;
  obfuscateData = false;
  authSubscription: Subscription;

  getCdrDevicesRequestBody = {
    Online: null,
    BundleStart: null,
    BundleEnd: null,
    GroupID: null,
    ACS: null,
    ShowNetworkBlocked: true,
    OnlyShowTLS: false,
    LoadTLS: true,
  };

  constructor(
    private titleService: TitleService,
    private navigationService: NavigationService,
    public layoutService: LayoutService,
    private genericService: GenericService,
    private paginationService: PaginationService,
    private router: Router,
    private endpoints: Endpoints,
    private tools: ToolsService,
    private auth: UserRightsService,
    private memory: MemoryService,
    private routeDictionary: Routes,
    private dialogRef: MatDialog,
    private toastSerive: ToastrService,
    private datePipe: DatePipe,
  ) {}

  cdrHeaderOptions: GenericTableHeaderOptions = {
    ShowSearch: true,
    SearchPlaceholder: 'Search Devices',
    DefaultDesc: true,
    EnableImport: true,
    SortItems: [
      {
        Name: 'DeviceNum',
        Display: 'Name',
      },
      {
        Name: 'DeviceType',
        Display: 'Type',
      },
      {
        Name: 'CustomerTradingName',
        Display: 'Customer',
      },
      {
        Name: 'MerchantName',
        Display: 'Merchant',
      },
      {
        Name: 'TerminalID',
        Display: 'Terminal ID',
      },
      {
        Name: 'SerialNumber',
        Display: 'Serial Number',
      },
      {
        Name: 'LastSeen',
        Display: 'Last Seen',
      },
      {
        Name: 'Usage',
        Display: 'Usage',
      },
    ],
    FilterItems: [
      {
        Name: 'Bundle Lower Bound (MB)',
      },
      {
        Name: 'Bundle Upper Bound (MB)',
      },
    ],
    DefaultSort: 'Usage',
    ToggleFilters: [
      {
        Name: 'Include Network Blocked Devices',
        DefaultValue: true,
      },
      {
        Name: 'Only show TLS Enabled',
        DefaultValue: false,
      },
    ],
  };

  cdrTableOptions: CardTableOptions = {
    titleProperty: 'name',
    subTitleProperty: '',
    textSize: 'regular',
    additionalProperty: 'data',
    rowId: 'id',
    indicatorColorProperty: 'color',
    selectedProperty: 'selected',
    isSelectable: false,
    flexCardLayout: false,
    propertyRowExclusions: ['color', 'selected', 'id', 'bundle'],
    stylePropertyPrefix: 'devices',
    clickableFlexCard: false,
  };

  cdrTableHeaders: CardTableHeader[] = [
    {
      ID: 'name',
      Text: 'Name',
      Width: 10,
      TooltipText: 'Double click to copy',
      OnClick: (rowValue: any) => {
        this.router.navigate([this.routeDictionary.CDRDeviceDetails], {
          state: {
            data: {
              CdrID: rowValue.id,
              KaID: rowValue.kadevice_id,
            },
          },
        });
      },
      OnDoubleClick: (rowValue: any) => {
        this.tools.CopyToClipboard(rowValue.name);
        this.toastSerive.info('', 'Copied to clipboard', { timeOut: 1000 });
      },
    },
    {
      Text: 'Type',
      Width: 5,
    },
    {
      Text: 'Customer',
      Width: 19,
    },
    {
      Text: 'Terminal ID',
      Width: 9,
    },
    {
      Text: 'Merchant',
      Width: 11,
    },
    {
      Text: 'Serial Number',
      Width: 11,
    },
    {
      Text: 'Last Seen',
      Width: 11,
    },
    {
      Text: 'Bundle',
      Width: 15,
    },
    // {
    //   Text: 'TLS',
    //   Width: 6,
    //   Icon: "lock",
    //   TooltipText: 'Has Used TLS',
    //   TooltipPosition: 'left',
    //   Wrapper: (_obj, elem) => {
        
    //     if (_obj != null) {
    //       if(_obj.value == "Yes")
    //       return true;
    //     }
    //     return false;
    //   },
    // },
    {
      Text: '',
      Width: 0,
    },
  ];

  cdrRowActions: CardTableAction[] = [
    {
      title: 'View',
      iconSrc: 'assets/icon/eye-outline.svg',
      color: 'primary',
      showIcon: true,
    },
  ];

  ngOnInit() {
    this.titleService.pageTitle = 'Devices';
    this.getCdrDevicesRequestBody.GroupID = this.auth.GetGroupID();
    this.cdrHeaderOptions.EnableImport = this.auth.GetUserPortalReadWrite().PortalWriteAccess;

    const memory = this.memory.getDetails();
    if (memory != null && memory.isCdr) {
      this.getCDRDevices(memory.orderBy, memory.search, memory.tableCount, memory.tableOffset, memory.desc);
      this.cdrSearch = memory.search;
    } else {
      this.getCDRDevices(this.orderCDRBy, '', this.cdrTableCount, this.cdrTableOffset, this.cdrDesc);
      this.cdrSearch = '';
    }

    this.authSubscription = this.auth.GetUser().subscribe((user) => {
      this.obfuscateData = user.isObfuscated;
      if (this.obfuscateData) {
        this.getCDRDevices(this.orderCDRBy, this.cdrSearch, this.cdrTableCount, this.cdrTableOffset, this.cdrDesc);
      }
    });
  }

  ngOnDestroy(): void {
    this.authSubscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.layoutService.addStickyHeaderForRoute(this.navigationService.GetCurrentRoute(), this.sticky);
  }

  setCDRTableToRefreshing() {
    setTimeout(() => {
      if (this.CDRTable) {
        this.CDRTable.StartRefresh();
      }
    });
  }

  setCDRTableToFinished() {
    setTimeout(() => {
      if (this.CDRTable) {
        this.CDRTable.EndRefresh();
      }
    });
  }

  openImportModal(): void {
    openFileImportDialog(this.dialogRef, {
      allowMultipleFiles: false,
      heading: "Import Merchant Names, Terminal ID's and Serial Numbers",
      acceptedFileTypes: ['.csv', '.txt'],
      submitButtonTitle: 'Import',
      endpoint: this.endpoints.IMPORT_DEVICE_INFO,
      templateImageName: 'assets/img/templateNameExample.png',
    }).subscribe((res) => {
      if (res == true) {
        //Reload table
        this.getCDRDevices(this.orderCDRBy, this.cdrSearch, this.cdrTableCount, this.cdrTableOffset, this.cdrDesc);
        this.toastSerive.success('', 'File successfully imported', { timeOut: 2000 });
      }
    });
  }

  getCDRDevices(orderBy: string, search: string, count: number, offset: number, desc: boolean) {
    this.loadingCDRDevices = true;
    this.setCDRTableToRefreshing();
    this.cdrLoadingError = false;
    this.genericService.POST(this.endpoints.GET_CDR_DEVICES(search, count, offset, orderBy, desc), this.getCdrDevicesRequestBody).subscribe(
      (resp: Object) => {
        const deviceData = resp['body'];
        // const deviceIds = [];
        this.totalCdrDevices = this.tools.ExtractPaginationFromHeaders(resp['headers']);
        if (deviceData != null) {
          const tmpData = [];
          deviceData.forEach((element) => {
            const tempObj = {
              id: element.id,
              name: element.name,
              deviceType: element.deviceType,
              customer: element.CustomerTradingName
                ? this.obfuscateData
                  ? this.tools.Obfuscate(element.CustomerTradingName, "Customer ", 8)
                  : element.CustomerTradingName
                : "",
              selected: false,
              bundle: element.InBundleAmount,
              color: "#949494",
              terminalid: element.TerminalID ?? "",
              merchant: element.MerchantName ?? "",
              serialNumber: element.SerialNumber ?? "",
            };

            const lastSeen =
              element.LastSeen == null
                ? "Unknown"
                : this.tools.FormatSwedishDateTime(
                    this.tools.ParseAPIDateWithTimezone(element.LastSeen),
                  );
            tempObj["lastSeen"] = lastSeen;
            tempObj["data"] = `${this.tools.FormatUsage(
              element.TotalUsage ? element.TotalUsage : 0,
            )} / ${this.tools.FormatUsage(tempObj["bundle"])} Used`;

            // tempObj['tls'] = element.TLSDevice != null ? element.TLSDevice == true ? 'Yes' : 'No' : ''

            let color = "#3FC944";
            let tooltip = "This device has used data today";
            if (!element.Online){
              color = "#C96D01";
              tooltip = "This device has not used data today"
            }
            if(element.DeviceStatus != "Installed"){
              color = "#e60000";
              tooltip = "This device is " + element.DeviceStatus;
            }

            if (element.IsCapped) {
              color = "#7E38B7";
              tooltip = `All sims on the device were automatically capped for exceeding limit. Capped on: ${element.LastBlocked ? this.datePipe.transform(element.LastBlocked, 'yyyy/MM/dd') : 'Unknown'}`;
            } else if (element.AllSimsSoftLocked) {
              color = "#f70713";
                tooltip = `All sims on the device were soft locked. Last sim soft locked on: ${element.LastBlocked ? this.datePipe.transform(element.LastBlocked, 'yyyy/MM/dd') : 'Unknown'}`;
            } else if (element.AllSimsNetworkBlocked) {
              color = "#000000";
                tooltip = `Both sims are network blocked. Last sim block on: ${element.LastBlocked ? this.datePipe.transform(element.LastBlocked, 'yyyy/MM/dd') : 'Unknown'}`;
            }
            
            tempObj["color"] = color;
            tempObj["toolTip"] = tooltip;
            tmpData.push(tempObj);
          });
          this.data = tmpData;
        } else {
          this.data = [];
        }

        this.loadingCDRDevices = false;
        this.setCDRTableToFinished();
        this.firstLoad = false;
        this.paginationService.emit();
      },
      () => {
        this.loadingCDRDevices = false;
        this.paginationService.emit();
        this.cdrLoadingError = true;
        this.setCDRTableToFinished();
      },
    );
  }

  handleDataRefresh(data: RefreshData): void {
    this.getCdrDevicesRequestBody.BundleStart = data.Filters.find((elem) => elem.Name == 'Bundle Lower Bound (MB)')?.value || null;
    this.getCdrDevicesRequestBody.BundleEnd = data.Filters.find((elem) => elem.Name == 'Bundle Upper Bound (MB)')?.value || null;
    if (this.getCdrDevicesRequestBody.BundleStart) {
      this.getCdrDevicesRequestBody.BundleStart *= 1_000_000;
    }
    if (this.getCdrDevicesRequestBody.BundleEnd) {
      this.getCdrDevicesRequestBody.BundleEnd *= 1_000_000;
    }
    this.orderCDRBy = data.Sort ?? '';
    this.cdrSearch = data.Search ?? '';
    this.cdrDesc = data.Desc ?? this.cdrDesc;
    this.cdrTableOffset = 0;
    this.currentCDRPage = 1;
    this.getCDRDevices(this.orderCDRBy, this.cdrSearch, this.cdrTableCount, this.cdrTableOffset, this.cdrDesc);
  }

  getPagedDevices(pageIndex: number) {
    this.cdrTableOffset = (pageIndex - 1) * this.cdrTableCount;
    this.currentCDRPage = pageIndex;
    this.getCDRDevices(this.orderCDRBy, this.cdrSearch, this.cdrTableCount, this.cdrTableOffset, this.cdrDesc);
  }

  onCdrAction(event) {
    if (event.title == 'View' && event.row != null) {
      this.memory.setDetails(true, this.orderCDRBy, this.cdrSearch, this.cdrTableCount, this.cdrTableOffset, this.cdrDesc);
      this.router.navigate([this.routeDictionary.CDRDeviceDetails], {
        state: {
          data: {
            CdrID: event.row.id,
            KaID: event.row.kadevice_id,
          },
        },
      });
    }
  }

  refreshData(event) {
    setTimeout(() => {
      event.target.complete();
    }, 2000);
  }

  filterChanged(change: { Name: string; value: any }) {
    if (change.Name == 'Include Network Blocked Devices') {
      this.getCdrDevicesRequestBody.ShowNetworkBlocked = change.value;
    }else if (change.Name == 'Only show TLS Enabled') {
      this.getCdrDevicesRequestBody.OnlyShowTLS = change.value;
    }
  }
}
